'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFooter = exports.DEFooterLink = exports.DEFooterIcon = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  borderTop: '1px solid ' + _.Colors.GREY2,
  padding: '10px ' + _.Layout.PADDING,
  background: _.Colors.GREY1,
  fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  fontSize: _.FontSizes.SIZE2,
  lineHeight: '22px',
  color: _.Colors.GREY3
}, function (_ref) {
  var isNarrow = _ref.isNarrow,
      isRtl = _ref.isRtl;

  if (isNarrow) return {};
  return {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: isRtl ? 'row-reverse' : 'row'
  };
});

var Author = _glamorous2.default.div({
  fontWeight: 'bold'
}, function (_ref2) {
  var isRtl = _ref2.isRtl;
  return {
    textAlign: isRtl ? 'right' : 'left'
  };
});

var Disclaimer = _glamorous2.default.div({}, function (_ref3) {
  var isNarrow = _ref3.isNarrow,
      isRtl = _ref3.isRtl;
  return {
    textAlign: !isNarrow && !isRtl || isNarrow && isRtl ? 'right' : 'left'
  };
});

var DEFooterIcon = exports.DEFooterIcon = _glamorous2.default.img({
  maxHeight: 20,
  verticalAlign: 'middle'
});

var DEFooterLink = exports.DEFooterLink = _glamorous2.default.a({
  textDecoration: 'none',
  color: _.Colors.BLUE1
});

var DEFooter = exports.DEFooter = function DEFooter(_ref4) {
  var isNarrow = _ref4.isNarrow,
      isRtl = _ref4.isRtl,
      authorLabel = _ref4.authorLabel,
      disclaimerLabel = _ref4.disclaimerLabel;
  return _react2.default.createElement(
    Wrapper,
    { isNarrow: isNarrow, isRtl: isRtl },
    _react2.default.createElement(
      Author,
      { isRtl: isRtl },
      authorLabel
    ),
    _react2.default.createElement(
      Disclaimer,
      { isNarrow: isNarrow, isRtl: isRtl },
      disclaimerLabel
    )
  );
};

DEFooter.propTypes = {
  isRtl: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool,
  authorLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disclaimerLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-footer/index.js
// module id = 2014
// module chunks = 0